import { render } from "./baseinfo.vue?vue&type=template&id=2844cd10&scoped=true"
import script from "./baseinfo.vue?vue&type=script&lang=js"
export * from "./baseinfo.vue?vue&type=script&lang=js"

import "./baseinfo.vue?vue&type=style&index=0&id=2844cd10&scoped=true&lang=css"
import "./baseinfo.vue?vue&type=style&index=1&id=2844cd10&lang=css"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2844cd10"]])

export default __exports__